import $ from "jquery";
import globals from "../globals";
import { readAPIErrorMessage } from "../helper/api_helper";

export function requestAccess(fd) {
  let hasCanceled_ = false;
  const wrappedPromise = new Promise((resolve, reject) => {
    $.ajax({
      url: globals.baseAPI + "access_requests",
      type: "POST",
      data: fd,
      success: function(data) {
        if (!hasCanceled_) {
          resolve({
            loaded: true,
            errors: ""
          });
        }
      },
      error: function(data) {
        if (!hasCanceled_) {
          reject({
            loaded: true,
            errors: readAPIErrorMessage(data)
          });
        }
      },
      contentType: false,
      processData: false
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    }
  };
}



// WEBPACK FOOTER //
// ./src/helper/access_helper.jsx